// component/policies/VendorPolicyPage.js
import React from "react";
import PolicyPageLayout from "./PolicyPageLayout";


const VendorPolicyPage = () => (
  <PolicyPageLayout title="Vendor / Service Provider Policy">
    <p><strong>Last Updated:</strong> June 2025</p>


    <h2>1. Provider Eligibility</h2>
    <p>Service providers must be at least 18 years of age and legally authorized to provide the services they list on Thurent. All business information must be accurate and verifiable.</p>


    <h2>2. Service Standards</h2>
    <ul>
      <li>Provide services as described in your listings</li>
      <li>Respond to booking requests within 24 hours</li>
      <li>Maintain professional conduct with all customers</li>
      <li>Comply with all applicable local laws and regulations</li>
      <li>Maintain valid licenses and certifications where applicable</li>
    </ul>


    <h2>3. Pricing and Payments</h2>
    <ul>
      <li>Set fair and transparent pricing</li>
      <li>Honor committed prices for confirmed bookings</li>
      <li>Process refunds in accordance with cancellation policies</li>
      <li>Maintain accurate GST/tax information</li>
    </ul>


    <h2>4. Prohibited Activities</h2>
    <ul>
      <li>Providing false or misleading service information</li>
      <li>Discriminating against customers</li>
      <li>Engaging in fraudulent billing practices</li>
      <li>Sharing customer personal information</li>
      <li>Any form of harassment or abusive behavior</li>
      <li>Uploading inappropriate or illegal content</li>
    </ul>


    <h2>5. Content Standards</h2>
    <p>All photos, descriptions, and content uploaded must be accurate, original, and appropriate. Thurent has zero tolerance for Child Sexual Abuse Material (CSAM) and will report violations to authorities.</p>


    <h2>6. Account Suspension</h2>
    <p>Thurent reserves the right to suspend or terminate provider accounts for:</p>
    <ul>
      <li>Violation of these policies</li>
      <li>Repeated customer complaints</li>
      <li>Fraudulent activity</li>
      <li>Non-compliance with service standards</li>
    </ul>


    <h2>7. Dispute Resolution</h2>
    <p>Disputes between providers and customers will be mediated by Thurent. Providers agree to cooperate in good faith during the resolution process.</p>
  </PolicyPageLayout>
);


export default VendorPolicyPage;



